import React from 'react';

/**
 * Input — text field. Dark: bg slate-900/50, 1px slate-700 border,
 * focus = 2px green border. 12px radius, 56px tall.
 */
export function Input({
  label,
  hint,
  error,
  type = 'text',
  disabled = false,
  style = {},
  containerStyle = {},
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  const borderColor = error
    ? 'var(--status-overdue)'
    : focus ? 'var(--primary)' : 'var(--border)';

  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 8, fontFamily: 'var(--font-sans)', ...containerStyle }}>
      {label && (
        <span style={{ fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-muted)' }}>{label}</span>
      )}
      <input
        type={type}
        disabled={disabled}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        style={{
          height: 'var(--control-h)',
          padding: '0 16px',
          background: 'var(--input-bg)',
          border: `${focus ? 2 : 1}px solid ${borderColor}`,
          borderRadius: 'var(--radius)',
          color: 'var(--text-body)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-body)',
          fontWeight: 'var(--fw-medium)',
          outline: 'none',
          opacity: disabled ? 0.5 : 1,
          transition: 'border-color .15s ease',
          ...style,
        }}
        {...rest}
      />
      {(error || hint) && (
        <span style={{ fontSize: 'var(--fs-xs)', color: error ? 'var(--status-overdue)' : 'var(--text-hint)' }}>
          {error || hint}
        </span>
      )}
    </label>
  );
}
